import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: "red",
  fontSize: "0.9rem",
}));

export default ErrorMessage;
